import config from "@/config";
import http from "@/utils/request";

const api = (path) => `${config.API_URL}${path}`;

export default {
	ltData: {
		url: api("/admin/lt_watch/ltData"),
		name: "数据大屏数据",
		get(params = {}) {
			return http.get(this.url, params);
		},
	},
};
